import React, { useState, useEffect, useRef } from 'react';
import './App.css';
// import AnimatedSunFlowerBG from './components/AnimatedSunFlowerBG';
import BackgroundAnimation from './components/BackgroundAnimation';
import BirthdayTitle from './components/BirthdayTitle';
import CakeNCandle from './components/CakeNCandle';
import MicDetector from './components/MicDetector';
import { triggerConfetti, endlessConfetti } from './components/Confetti';
import birthdaySongLongLive from './assets/longlive2.mp3';
import EnvelopeCard from './components/EnvelopeCard';
import GiftBox from './components/GiftBox';
import MicPermissionModal from './components/MicPermissionModal'; 
import SunFlower from './components/SunFlower';
import AnimationPicture from './components/AnimationPicture';
import { sendOpenNotification, sendScanNotification } from './utils/sendNotification';

const App = () => {
  const [permissionGranted, setPermissionGranted] = useState(false); 
  const [isBlownOut, setIsBlownOut] = useState(false);
  const [micReady, setMicReady] = useState(false);
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  const [isGiftOpen, setIsGiftOpen] = useState(false);
  const audioRef = useRef(null);

  const handleMicReady = () => {
    try {
      const audio = new Audio(birthdaySongLongLive);
      audio.volume = 1.0;
      audioRef.current = audio;

      audio.muted = true;
      audio.play().then(() => {
        audio.pause();
        audio.muted = false;
        setAudioUnlocked(true);
        console.log("✅ Audio unlocked");
        
      }).catch((e) => {
        console.warn("❌ Audio unlock failed:", e);
      });

    } catch (e) {
      console.warn("❌ Audio creation failed:", e);
    }

    setMicReady(true);
  };

  const blowOutCandle = () => {
    setIsBlownOut(true);

    if (!audioRef.current) {
      try {
        const audio = new Audio(birthdaySongLongLive);
        audio.volume = 1.0;
        audioRef.current = audio;
      } catch (e) {
        console.warn("Audio creation failed:", e);
      }
    }

    if (audioRef.current && audioRef.current.paused) {
      audioRef.current.play().then(() => {
        console.log("🎵 Birthday song playing");
      }).catch((e) => {
        console.warn("❌ Audio playback error:", e);
      });
    }

    triggerConfetti();
    endlessConfetti();
  };

  useEffect(() => {
    sendScanNotification();
  }, []);

  useEffect(() => {
    if (isGiftOpen) {
      sendOpenNotification('gift box');
    }
  }, [isGiftOpen]);

  useEffect(() => {
    if (isBlownOut && micReady && audioUnlocked && audioRef.current) {
      audioRef.current.play().then(() => {
        console.log("🎵 Birthday song playing");

      }).catch((e) => {
        console.warn("❌ Audio still blocked:", e);
      });

      triggerConfetti();
      endlessConfetti();
    }
  }, [isBlownOut, micReady, audioUnlocked]);

  return (
    <>
      <div className="App">
        {/* <AnimatedSunFlowerBG /> */}
        <BackgroundAnimation />

        {permissionGranted && isBlownOut && <BirthdayTitle />}

        {permissionGranted && (
          <CakeNCandle
            isBlownOut={isBlownOut}
            onDoubleTap={blowOutCandle}
          />
        )}

        {!isBlownOut && permissionGranted && (
          <MicDetector
            onBlowOut={blowOutCandle}
            onMicReady={handleMicReady}
          />
        )}

        {isBlownOut && (
          <p className="cake-ready-message"></p>
        )}
      </div>

      {isBlownOut && (
        <div className="floating-envelope">
          <EnvelopeCard />
          <GiftBox isOpen={isGiftOpen} onClick={() => setIsGiftOpen(prev => !prev)} />
        </div>
      )}

      {isGiftOpen && (
        <AnimationPicture onClose={() => setIsGiftOpen(false)} />
      )}

      <div className="instruction-card">
        <SunFlower className="left" />
        <h4>Instruction</h4>
        <p>Blow the mic or double tap the cake</p>
        <p>Don't forget to open the card and gift box.</p>
        <SunFlower className="right" />
      </div>

      {!permissionGranted && (
        <MicPermissionModal onAllow={() => setPermissionGranted(true)} />
      )}
    </>
  );
};

export default App;
